import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="relative w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-semibold text-foreground-950 text-center mb-3">
          Najczęściej zadawane pytania
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14">
          Wszystko, co musisz wiedzieć o USFansSpreadsheet
        </p>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={item.id}
              className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="whitespace-nowrap cursor-pointer w-full text-left px-5 md:px-6 py-4 md:py-5 flex items-center justify-between gap-4 hover:bg-background-50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all ${openIdx === idx ? "bg-foreground-950 text-background-50 rotate-45" : "bg-background-100 text-foreground-500"}`}>
                  <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </button>
              {openIdx === idx && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map((item) => ({
              "@type": "Question",
              "name": item.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}